import moment from 'moment-timezone';

const momentFormat = (
  value: number | string,
  format: string = 'DD/MM/YYYY hh:mm',
): string => {
  return moment(String(value)).format(format);
};

const momentTz = (
  value?: number | string | Date,
  format: string | null = null,
): moment.Moment => {
  const timezone = 'Europe/Rome';
  let newDate: moment.Moment;
  const valueTz = value || moment().tz(timezone);

  if (moment.isMoment(valueTz)) {
    // valueTz is Moment
    newDate = valueTz.clone().tz(timezone);
  } else if (valueTz instanceof Date) {
    // valueTz is Date
    newDate = moment(valueTz).tz(timezone);
  } else {
    // valueTz is String or number
    const newDateGuess = format
      ? moment.tz(String(valueTz), format, timezone)
      : moment.tz(String(valueTz), timezone);
    newDate = newDateGuess;
  }

  return newDate;
};

const momentTzFormat = (
  value: number | string,
  format: string = 'DD/MM/YYYY hh:mm',
): string => {
  return momentTz(value).format(format);
};

const convertToServerDate = (value: number | string): string => {
  return moment(value).format('YYYY-MM-DD');
};

const convertMomentToDate = (value: moment.Moment): Date => {
  const year = value.year();
  const month = value.month();
  const date = value.date();
  const hour = value.hour();
  const minute = value.minute();
  const second = value.second();
  const millisecond = value.millisecond();

  const newDate = new Date(
    year,
    month,
    date,
    hour,
    minute,
    second,
    millisecond,
  );

  return newDate;
};

export {
  momentFormat,
  momentTz,
  momentTzFormat,
  convertToServerDate,
  convertMomentToDate,
};
